import styled from 'styled-components';

export const TurntableBase = styled.div`
    position: relative;
    width: ${props => props.baseWidth ? `${props.baseWidth}px` : '500px'};
    height: ${props => props.baseHeight ? `${props.baseHeight}px` : '500px'};
    background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
    border-radius: 20px;
    box-shadow: 
        0 10px 40px rgba(0, 0, 0, 0.6),
        inset 0 2px 10px rgba(0, 0, 0, 0.3);
    border: 2px solid rgba(244, 212, 163, 0.2);
    overflow: visible;
    transition: all 0.3s ease;
`;

export const TurntablePlatter = styled.div.attrs(props => {
    const layout = props.layout || {};
    const rotation = props.rotation || 0;
    
    // 构建 transform - 这是频繁变化的部分，移到内联 style 中
    let transformParts = [];
    const needsCentering = !layout.top && !layout.bottom && !layout.left && !layout.right;
    if (needsCentering) {
        transformParts.push('translate(-50%, -50%)');
    }
    if (layout.transform) {
        transformParts.push(layout.transform);
    }
    transformParts.push(`rotate(${rotation}deg)`);
    
    return {
        style: {
            transform: transformParts.join(' '),
        },
    };
})`
    position: absolute;
    ${props => {
        const layout = props.layout || {};
        let styles = '';
        // 位置：如果有 layout 配置，使用 layout；否则默认居中
        if (layout.top !== undefined) {
            styles += `top: ${typeof layout.top === 'string' ? layout.top : `${layout.top}px`}; `;
        } else if (!layout.left && !layout.right) {
            styles += `top: 50%; `;
        }
        if (layout.right !== undefined) styles += `right: ${typeof layout.right === 'string' ? layout.right : `${layout.right}px`}; `;
        if (layout.bottom !== undefined) styles += `bottom: ${typeof layout.bottom === 'string' ? layout.bottom : `${layout.bottom}px`}; `;
        if (layout.left !== undefined) {
            styles += `left: ${typeof layout.left === 'string' ? layout.left : `${layout.left}px`}; `;
        } else if (!layout.top && !layout.bottom) {
            styles += `left: 50%; `;
        }
        // 大小：优先使用 layout，其次使用 size prop
        if (layout.width !== undefined) {
            styles += `width: ${typeof layout.width === 'string' ? layout.width : `${layout.width}px`}; `;
        } else {
            styles += `width: ${props.size ? `${props.size}px` : '300px'}; `;
        }
        if (layout.height !== undefined) {
            styles += `height: ${typeof layout.height === 'string' ? layout.height : `${layout.height}px`}; `;
        } else {
            styles += `height: ${props.size ? `${props.size}px` : '300px'}; `;
        }
        return styles;
    }}
    opacity: 1;
    pointer-events: auto;
    background: radial-gradient(
        circle,
        #1a1a1a 0%,
        #0a0a0a 30%,
        #000000 50%,
        #0a0a0a 70%,
        #1a1a1a 100%
    );
    border-radius: 50%;
    box-shadow: 
        inset 0 0 40px rgba(0, 0, 0, 0.9),
        0 0 20px rgba(0, 0, 0, 0.8),
        inset 0 2px 5px rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: grab;
    user-select: none;
    transition: none; /* 移除 transition，使用纯 JavaScript 控制以实现更流畅的实时响应 */
    will-change: transform; /* 提示浏览器优化 transform 性能 */
    
    &:active {
        cursor: grabbing;
    }
`;

export const RecordImage = styled.div`
    position: absolute;
    width: 60%;
    height: 60%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url('/images/33y-cover.webp');
    background-size: cover;
    background-position: center 70%;
    background-repeat: no-repeat;
    border-radius: 50%;
    opacity: 0.8;
    mix-blend-mode: screen;
    filter: contrast(1.3) brightness(0.7);
    z-index: 1;
`;

export const RecordGrooves = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-image: 
        repeating-radial-gradient(
            circle at center,
            transparent 30%,
            transparent 30.3%,
            rgba(244, 212, 163, 0.08) 30.3%,
            rgba(244, 212, 163, 0.08) 30.6%,
            transparent 30.6%,
            transparent 30.9%,
            rgba(244, 212, 163, 0.06) 30.9%,
            rgba(244, 212, 163, 0.06) 31.2%,
            transparent 31.2%,
            transparent 31.5%,
            rgba(244, 212, 163, 0.05) 31.5%,
            rgba(244, 212, 163, 0.05) 31.8%,
            transparent 31.8%,
            transparent 32.1%,
            rgba(244, 212, 163, 0.04) 32.1%,
            rgba(244, 212, 163, 0.04) 32.4%,
            transparent 32.4%,
            transparent 32.7%,
            rgba(244, 212, 163, 0.03) 32.7%,
            rgba(244, 212, 163, 0.03) 33%,
            transparent 33%,
            transparent 33.3%,
            rgba(244, 212, 163, 0.025) 33.3%,
            rgba(244, 212, 163, 0.025) 33.6%,
            transparent 33.6%,
            transparent 33.9%,
            rgba(244, 212, 163, 0.02) 33.9%,
            rgba(244, 212, 163, 0.02) 34.2%,
            transparent 34.2%,
            transparent 34.5%,
            rgba(244, 212, 163, 0.015) 34.5%,
            rgba(244, 212, 163, 0.015) 34.8%,
            transparent 34.8%,
            transparent 35.1%,
            rgba(244, 212, 163, 0.01) 35.1%,
            rgba(244, 212, 163, 0.01) 35.4%,
            transparent 35.4%,
            transparent 35.7%,
            rgba(244, 212, 163, 0.008) 35.7%,
            rgba(244, 212, 163, 0.008) 36%,
            transparent 36%,
            transparent 36.3%,
            rgba(244, 212, 163, 0.006) 36.3%,
            rgba(244, 212, 163, 0.006) 36.6%,
            transparent 36.6%,
            transparent 36.9%,
            rgba(244, 212, 163, 0.005) 36.9%,
            rgba(244, 212, 163, 0.005) 37.2%,
            transparent 37.2%,
            transparent 37.5%,
            rgba(244, 212, 163, 0.004) 37.5%,
            rgba(244, 212, 163, 0.004) 37.8%,
            transparent 37.8%,
            transparent 38.1%,
            rgba(244, 212, 163, 0.003) 38.1%,
            rgba(244, 212, 163, 0.003) 38.4%,
            transparent 38.4%,
            transparent 38.7%,
            rgba(244, 212, 163, 0.002) 38.7%,
            rgba(244, 212, 163, 0.002) 39%,
            transparent 39%,
            transparent 39.3%,
            rgba(244, 212, 163, 0.001) 39.3%,
            rgba(244, 212, 163, 0.001) 39.6%,
            transparent 39.6%,
            transparent 100%
        );
    pointer-events: none;
    z-index: 2;
    mask: radial-gradient(circle, transparent 30%, black 30%);
    -webkit-mask: radial-gradient(circle, transparent 30%, black 30%);
`;

